import { SUPABASE_URL } from '../supabaseClient';

/* Analyse IA du dossier d'un appel d'offres (fonction Edge boamp-analyze), avec le jeton de
   session de l'utilisateur. */
export function analyzeTender(idweb, accessToken) {
  return fetch(`${SUPABASE_URL}/functions/v1/boamp-analyze`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ idweb }),
  });
}
